import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "../homePage/Shared/CustomSwiper";
import Breadcrump from "../../Components/Breadcrump";
import ProductCard from "../products/ProductCard";

import allProductsListingApi from "../../api/allProductsListing";
import {Row, Col} from "react-bootstrap";

function ListPage() {
  const { "*": slug } = useParams();
  const [products, setProducts] = useState([]);

  const fetchAllproducts = async () => {
    try {
      const res = await allProductsListingApi.product_list(slug);

      if (res.code === 200) {
        const result = res.data;
        setProducts(result?.products);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchAllproducts();
  }, [slug]);

   const productInfo = products[0];

  return (
    <>
      <Breadcrump title={"Shop"} />

      {/* PRODUCTS SECTION */}
      {products && products.length > 0 ? (
        <div className="py-4 bg-white">
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="text-start">
                <h4 className="section-title">Our Products</h4>
              </div>
              <Row className="g-3 mt-2">
                {products.map((product, index) => (
                  <Col lg={3} md={6} sm={6} xs={6} key={product.id || index}>
                    <ProductCard item={product} />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-5 bg-white">
          <div className="container">
            <div className="text-center">
              <p>No Product Found </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ListPage;
